'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');

const Keys = Backbone.Collection.extend({
    model: Key
});

class RelatedKeys extends Keys {
    /**
     * 関連する Key を保持する Collection
     */
    initialize() {
        this.listenTo(this, 'add', this._update);
        this.listenTo(this, 'remove', this._update);
    }

    _update() {
        // ContentVersion が削除された場合、他に Version が存在しないのならば対応する Content も削除する必要があるが
        // 他の Version が残っている場合は Content も残しておく必要がある。
        // そのため、残っている ContentVersion から Content を取得して Keys を更新する。
        const keysExcludingContent = this.filter(k => k.kind !== 'DataContent');
        const keys = _.union(this.at(0), keysExcludingContent, this.getContentKeysByVersionKeys());
        this.reset(_.uniq(keys));
    }

    get keys() {
        return this.models;
    }

    get primaryKey() {
        return this.at(0);
    }

    getKeysWithoutPrimaryKey() {
        return this.slice(1);
    }

    getKeysByKind(kind) {
        return this.filter(k => k.kind == kind);
    }

    getActionKeys() {
        return this.getKeysByKind('Action');
    }

    getContentKeys() {
        return this.getKeysByKind('DataContent');
    }

    getContentVersionKeys() {
        return this.getKeysByKind('DataContentVersion');
    }

    getContentKeysByVersionKeys() {
        return _.map(this.getContentVersionKeys(), k => new Key(k.parent.toString()));
    }

    getDiagramKeys() {
        return this.getKeysByKind('Diagram');
    }

    getRecordKeys() {
        return this.getKeysByKind('Record');
    }

    getRelationKeys() {
        return this.getKeysByKind('Relation');
    }

    union(relatedKeys) {
        if(!relatedKeys instanceof RelatedKeys) {
            throw `${relatedKeys} is not a RelatedKeys`;
        }

        return new RelatedKeys(_.union(this.keys, relatedKeys.keys));
    }

    contains(key) {
        return this.filter(k => k.isEqual(key)).length > 0;
    }
}

module.exports = RelatedKeys;



// WEBPACK FOOTER //
// ./common/domain/value/related-keys.js